export default __webpack_public_path__ + "static/media/QA.48096f3a.svg";